import React, { useState, useEffect } from "react";
import hero from "../../assets/images/resto-hero.avif";

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  // Animation trigger on mount
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToMenu = () => {
    if (isScrolling) return;
    
    setIsScrolling(true);
    const menuSection = document.getElementById("menu");
    if (menuSection) {
      const offsetTop = menuSection.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
      
      // Reset scrolling state after animation
      setTimeout(() => {
        setIsScrolling(false);
      }, 1000);
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden bg-gray-900"
    >
      {/* Background Image with Simple Overlay */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-90 transition-transform duration-700 ease-out"
          style={{
            backgroundImage: `url(${hero})`,
            transform: `scale(${isVisible ? 1 : 1.1})`,
          }}
        >
          {/* Simple Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/50 transition-all duration-700"></div>
        </div>

        {/* Subtle Pattern Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl">
          {/* Main Heading with Fade In */}
          <div
            className={`space-y-6 transition-all duration-1000 ease-out ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-8"
            }`}
          >
            {/* Welcome Badge */}
            <div className="inline-block transform transition-all duration-700 delay-100 hover:scale-105">
              <div className="bg-white/10 backdrop-blur-sm rounded-full px-6 py-3 border border-white/20 inline-flex items-center gap-3 transition-all duration-300 hover:bg-white/15">
                <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
                <span className="text-white font-body text-sm font-medium tracking-wider">
                  WELCOME TO FOOD PALACE
                </span>
              </div>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-bold text-white leading-tight">
              <span className="block opacity-0 animate-fade-in-delay hover:opacity-90 transition-opacity duration-300">
                Experience
              </span>
              <span className="block text-primary opacity-0 animate-fade-in-delay-2 hover:brightness-110 transition-all duration-300">
                Fine Dining
              </span>
              <span className="block opacity-0 animate-fade-in-delay-3 hover:opacity-90 transition-opacity duration-300">
                Reimagined
              </span>
            </h1>
          </div>
        </div>
      </div>

            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        {/* <button
          onClick={scrollToMenu}
          className="flex flex-col items-center text-white/60 hover:text-white transition-colors duration-300 animate-bounce-slow"
          aria-label="Scroll to menu"
        >
          <span className="text-sm font-body mb-2 tracking-wider">EXPLORE</span>
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </button> */}
      </div>

      {/* Minimal Decorative Elements with animation */}
      <div 
        className="absolute top-1/4 right-1/4 w-64 h-64 bg-primary/5 rounded-full mix-blend-overlay filter blur-3xl opacity-50 animate-float-slow"
        style={{ animationDelay: "0.5s" }}
      ></div>
      <div 
        className="absolute bottom-1/4 left-1/4 w-80 h-80 bg-secondary/5 rounded-full mix-blend-overlay filter blur-3xl opacity-50 animate-float"
        style={{ animationDelay: "1s" }}
      ></div>

      {/* Styles */}
      <style jsx>{`
        @keyframes fade-in-delay {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0) scale(1);
          }
          50% {
            transform: translateY(-20px) scale(1.05);
          }
        }

        @keyframes float-slow {
          0%, 100% {
            transform: translateY(0) scale(1);
          }
          50% {
            transform: translateY(-15px) scale(1.03);
          }
        }

        @keyframes pulse-glow {
          0%, 100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.1);
          }
        }

        .animate-fade-in-delay {
          animation: fade-in-delay 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.2s forwards;
        }

        .animate-fade-in-delay-2 {
          animation: fade-in-delay 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.4s forwards;
        }

        .animate-fade-in-delay-3 {
          animation: fade-in-delay 0.8s cubic-bezier(0.4, 0, 0.2, 1) 0.6s forwards;
        }

        .animate-bounce {
          animation: bounce 1.5s infinite ease-in-out;
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }

        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }

        .animate-pulse-glow {
          animation: pulse-glow 2s ease-in-out infinite;
        }

        /* Smooth scrolling */
        html {
          scroll-behavior: smooth;
        }

        /* Smooth transitions for all interactive elements */
        * {
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        }
      `}</style>
    </section>
  );
};

export default Hero;